import { render, staticRenderFns } from "./ticketsItem.vue?vue&type=template&id=55b35c90&scoped=true"
import script from "./ticketsItem.vue?vue&type=script&lang=js"
export * from "./ticketsItem.vue?vue&type=script&lang=js"
import style0 from "./ticketsItem.vue?vue&type=style&index=0&id=55b35c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b35c90",
  null
  
)

export default component.exports